<template>
  <div class="VATConsumptionReport container-fluid">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <adaptive-game-report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></adaptive-game-report-filter-bar>
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-2Perc">
          <sortable-list v-if="showVATConsumptionReportList" v-bind:responseObj="getVATConsumptionReportResp" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="5"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>        
  </div>  
</template>

<script>
import AdaptiveGameReportFilterBar from '@/components/reports/adaptive-game-report/AdaptiveGameReportFilterBar'
import list from '@/pages/SortableList'
import Loader from '@/components/dashboard/Loader'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedGroupCourseObj: null,
      selectedCohortObj: null,
      showExportButton: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      reportRespArr: [],
      showVATConsumptionReportList: false,
      columnAlias: [],
      columnRespKey: [],
      columnNameToShow: [],
      linkColumnNames: [],
      responseToPass: [],
      responseToPassForExport: [],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      csvFileName: '',
      sortColumnNames: ['UserName', 'SessionNo', 'TotalTime', 'VideoPercentage', 'AudioPercentage', 'TextPercentage', 'VideoModeTime', 'AudioModeTime', 'TextModeTime', 'VideoDuration']
    }
  },
  components: {
    'adaptive-game-report-filter-bar': AdaptiveGameReportFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group course object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        this.getVATConsumptionReport()
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        this.getVATConsumptionReportForCSV()
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
      this.processAndExecuteSelectedOperation()
    },
    setGroupObj (value) {
      // AK: When user selected particular Group object then update it in parent file too
      this.selectedGroupObj = value
    },
    getVATConsumptionReportForCSV: function () {
      var storeObj = this.$store
      var _this = this
      this.reportRespArr = []
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getVATConsumptionForExport(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Reports
              _this.$store.state.isLoading = false
              _this.csvFileName = 'VATConsumption(' + this.selectedGroupCourseObj.GroupName + ' - ' + this.selectedGroupCourseObj.CourseTitle + ')'
              return csvHelper.exportFromServerData(responseObj.data, _this.csvFileName)
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('VALUES are NULL hence declined LOADING ALG Report List')
      }
    },
    getVATConsumptionReport: function () {
      var storeObj = this.$store
      var _this = this
      this.reportRespArr = []
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getVATConsumptionReports(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Reports
              _this.$store.state.isLoading = false
              _this.reportRespArr = responseObj.data
              // console.log('this.getALGReport >>> ' + JSON.stringify(_this.reportRespArr))
              if (parseInt(_this.reportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showVATConsumptionReportList = false
              } else {
                this.addColumnAlias()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('VALUES are NULL hence declined LOADING ALG Report List')
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      this.columnAlias = ['Video', 'User', 'Session #', 'Last Session', 'Allowed Mode', 'Video Duration', 'Video Playback', 'Audio Playback', 'Text', 'Total #', 'Video %', 'Audio %', 'Text %']
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      this.columnRespKey = ['VideoTitle', 'UserName', 'SessionNo', 'IsLastSession', 'AllowedMode', 'VideoDuration', 'VideoModeTime', 'AudioModeTime', 'TextModeTime', 'TotalTime', 'VideoPercentage', 'AudioPercentage', 'TextPercentage']
      this.bindResponseObj()
    },
    bindResponseObj: function () {
      this.responseToPass = []
      for (var i = 0; i < this.reportRespArr.VATConsumptions.length; i++) {
        var obj = {
          'VideoTitle': this.reportRespArr.VATConsumptions[i].VideoTitle,
          'UserName': this.reportRespArr.VATConsumptions[i].UserName,
          'SessionNo': this.reportRespArr.VATConsumptions[i].SessionNo,
          'IsLastSession': this.reportRespArr.VATConsumptions[i].IsLastSession ? 'Yes' : 'No',
          'AllowedMode': this.reportRespArr.VATConsumptions[i].AllowedMode,
          'VideoDuration': this.reportRespArr.VATConsumptions[i].VideoDuration,
          'VideoModeTime': this.reportRespArr.VATConsumptions[i].VideoModeTime,
          'AudioModeTime': this.reportRespArr.VATConsumptions[i].AudioModeTime,
          'TextModeTime': this.reportRespArr.VATConsumptions[i].TextModeTime,
          'TotalTime': this.reportRespArr.VATConsumptions[i].TotalTime,
          'VideoPercentage': this.reportRespArr.VATConsumptions[i].VideoPercentage,
          'AudioPercentage': this.reportRespArr.VATConsumptions[i].AudioPercentage,
          'TextPercentage': this.reportRespArr.VATConsumptions[i].TextPercentage
        }
        this.responseToPass.push(obj)
      }
      obj = {
        'VideoTitle': 'TOTAL',
        'UserName': '',
        'SessionNo': '',
        'IsLastSession': '',
        'AllowedMode': '',
        'VideoDuration': this.reportRespArr.TotalDuration,
        'VideoModeTime': this.reportRespArr.TotalVideoModeTime,
        'AudioModeTime': this.reportRespArr.TotalAudioModeTime,
        'TextModeTime': this.reportRespArr.TotalTextModeTime,
        'TotalTime': this.reportRespArr.TotalTime,
        'VideoPercentage': this.reportRespArr.TotalVideoPercentage,
        'AudioPercentage': this.reportRespArr.TotalAudioPercentage,
        'TextPercentage': this.reportRespArr.TotalTextPercentage
      }
      this.responseToPass.push(obj)
      // console.log('this.responseToPass >>>> ' + JSON.stringify(this.responseToPass))
      this.bindColumnsNameAndAlias()
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showVATConsumptionReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showVATConsumptionReportList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getVATConsumptionReportRespForExport, this.columnRespKey, this.columnAlias, 'VATConsumption(' + this.selectedGroupCourseObj.GroupName + ' - ' + this.selectedGroupCourseObj.CourseTitle + ')')
    }
  },
  computed: {
    getVATConsumptionReportResp: {
      get: function () {
        return this.responseToPass
      }
    },
    getVATConsumptionReportRespForExport: {
      get: function () {
        return this.responseToPass
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'VATConsumptionReport'
}
</script>

<style scoped>
.VATConsumptionReport {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.border-red {
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/pages/VATConsumptionReport.vue